<ng-container *transloco="let t; read: 'test-configuration-drawer-component'">
  @if (drawerOpen) {
    <div>
      <xi-drawer
        #drawer
        [open]="open()"
        [interceptClose]="true"
        (onClose)="cancel()"
        color="CX"
        [silverBg]="true"
      >
        <div slot="title">Test {{ configuration()?.name }}</div>
        <div slot="body" class="test-config__body-container">
          <div class="test-config__container">
            <form class="test-config__left-side-container">
              <div class="test-config__left-side">
                <h2 class="kxi-text-medium kxi-text-600">{{ t('test-header') }}</h2>
                <div class="test-config__test-config-new-doc-header">
                  <p class="kxi-text-small kxi-text-600">
                    {{ t('documents-x', { length: testDocuments.length }) }}
                  </p>
                  <div>
                    <xi-default-button
                      text="{{ t('new-document') }}"
                      type="button"
                      fill="no-fill"
                      iconLeft="add_circle"
                      [hasAnimation]="false"
                      color="CX"
                      [disabled]="evaluationInProgress"
                      (onClick)="addDocument()"
                    ></xi-default-button>
                  </div>
                </div>
                @for (document of testDocuments; track document; let i = $index) {
                  <div
                    class="test-config__new-test-doc-container"
                    [ngClass]="
                      this.selectedDocument.id === document.id
                        ? 'test-config__test-doc-selected'
                        : ''
                    "
                  >
                    <div class="test-config__test-document-container">
                      <div class="test-config__scroll" #documentViewer>
                        <div
                          (focus)="onDocSelected(i)"
                          [textContent]="document.text"
                          (input)="
                            docTextInputChange$.next({ event: $event, index: i });
                            clearSpans($event, document)
                          "
                          (focusout)="onFocusOut($event, i)"
                          [attr.contenteditable]="true"
                          [name]="'doc' + i"
                          [id]="'highlighted-test-doc-' + i"
                          class="test-config__test-document-textbox"
                        ></div>
                      </div>
                    </div>
                    <div class="test-config_new-doc-button-container">
                      @if (document.hasBeenAnalyzed) {
                        <div class="test-config__analyzed-status">
                          <xi-icon icon="circle_check_filled" color="success"></xi-icon>
                          <p>{{ t('analyzed') }}</p>
                        </div>
                      }
                      @if (!document.hasBeenAnalyzed) {
                        <div class="test-config__analyzed-status">
                          <xi-icon icon="warning" iconSize="small"></xi-icon>
                          <p>{{ t('not-analyzed') }}</p>
                        </div>
                      }
                      <xi-default-button
                        text="{{ t('delete') }}"
                        type="button"
                        fill="no-fill"
                        [hasAnimation]="false"
                        (onClick)="removeDocument(i)"
                      ></xi-default-button>
                    </div>
                  </div>
                }
              </div>
              <div class="test-config__test-config-bottom">
                <xi-accordion>
                  <div slot="children">
                    <xi-accordion-item [id]="0" title="{{ t('include') }}">
                      <div slot="children" class="test-config-test-config-checkboxes-container">
                        @for (box of includeCheckboxes; track box; let i = $index) {
                          <div>
                            <xi-checkbox
                              [label]="box.label"
                              [name]="'box' + i"
                              [(ngModel)]="box.isChecked"
                              [disabled]="box.numUsed < 1"
                              (onChange)="checkCheckboxValidity()"
                            ></xi-checkbox>
                          </div>
                        }
                      </div>
                    </xi-accordion-item>
                  </div>
                </xi-accordion>
                <div class="test-config__test-config-actions">
                  <xi-default-button
                    text="{{ t('clear-all') }}"
                    fill="outline"
                    type="button"
                    (onClick)="clearAll()"
                  ></xi-default-button>
                  <xi-default-button
                    text="{{ t('test') }}"
                    (onClick)="test()"
                    [disabled]="!testDocInputValid || !checkboxesValid || evaluationInProgress"
                  ></xi-default-button>
                </div>
              </div>
            </form>
            <div class="test-config__right-side-container">
              @if (!evaluationInProgress && selectedDocument.hasBeenAnalyzed) {
                <div class="test-config__scroll" #documentViewer>
                  <app-document-nlp-output
                    [document]="selectedDocument"
                    [options]="options"
                    [(closedGroups)]="closedGroups"
                    [isTestMode]="true"
                    [includedAnalyticItems]="includedAnalyticItems"
                    (entityToEditChange)="onEntityToEditChange($event)"
                    (topicToEditChange)="onTopicToEditChange($event)"
                    (documentSectionsChange)="onDocumentSectionsChange($event)"
                    rowTooltip="{{ t('row-tooltip') }}"
                  ></app-document-nlp-output>
                </div>
              }
              @if (evaluationInProgress) {
                <div class="xi-loader-container__center">
                  <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
                </div>
              }
              @if (!evaluationInProgress && !selectedDocument.hasBeenAnalyzed) {
                <div class="test-config__info-box-wrapper">
                  <h2 class="kxi-text-large kxi-text-center kxi-text-600">
                    {{ t('test-your-configuration') }}
                  </h2>
                  <p class="kxi-text-normal kxi-text-center">
                    {{ t('doc-has-not-been-analyzed') }}
                  </p>
                </div>
              }
            </div>
          </div>
        </div>
        <div slot="footer" class="test-config__save-bar">
          <xi-default-button
            text="{{ t('cancel') }}"
            fill="text"
            (onClick)="cancel()"
          ></xi-default-button>
          <div class="xi-loader-button-container">
            <div>
              <xi-default-button text="{{ t('save-exit') }}" (onClick)="save()">
              </xi-default-button>
            </div>
          </div>
        </div>
      </xi-drawer>
    </div>
  }
</ng-container>
